<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="do-type" class="form-label">Option type *</label>
              <select class="form-control" id="do-type" v-model="entity.optionType">
                <option value=""></option>
                <option v-for="(opt, i) in optionTypes" :value="opt.code">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="do-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="do-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="do-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="do-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="do-val-alpha" class="form-label">Value alpha</label>
              <input type="text" class="form-control" id="do-val-alpha" v-model="entity.valueAlpha"/>
            </div>
            <div class="form-group">
              <label for="do-val-num" class="form-label">Value numeric</label>
              <input type="number" step="0.01" class="form-control" id="do-val-num" v-model="entity.valueNumeric"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="vb" class="form-label">Value boolean</label>
              <div class="material-switch">
                <input id="vb" type="checkbox" v-model="entity.valueBoolean"/>
                <label for="vb" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="do-acc" class="form-label">Access codes</label>
              <input type="text" class="form-control" id="do-acc" v-model="entity.accessCodes"/>
            </div>
            <div class="form-group">
              <label for="do-sys" class="form-label">System area</label>
              <select class="form-control" id="do-type" v-model="entity.systemArea">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SYSTEM_AREA')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="do-ex" class="form-label">External code</label>
              <input type="text" class="form-control" id="do-ex" v-model="entity.externalCode"/>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label for="location-comments" class="form-label">Comments</label>
              <textarea class="form-control" rows="5" id="location-comments" v-model="entity.notes"></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'DataOption',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'dataOptions',
        transformForUpdate: {
          optionType: this.toEmpty,
          valueNumeric: this.toZero,
          systemArea: this.toMinus
        },
        editEntityScreen: 'Admin - Edit/View Data Option',
        newEntityScreen: 'Admin - Data Options',
        tab: 'main',
        boxes: [
          {
            prop: 'optionType',
            id: 'code'
          },
          {
            prop: 'systemArea',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          code: null,
          name: null,
          valueBoolean: null,
          valueNumeric: null,
          valueAlpha: null,
          optionType: null,
          accessCodes: null,
          externalCode: null,
          systemArea: null,
          notes: null,
          modifiedDate: null,
          modifiedBy: null,
          changeLog: null,
          filter1: null,
          filter2: null,
          filter3: null,
          tenant: null,
          userGroup: null,
          maiUser: null,
          partyGroup: null,
          category: null
        },
        entityName: 'data-option'
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.entity.optionType &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0 &&
          this.entity.optionType !== null && this.entity.optionType !== ''
      },
      optionTypes () {
        return this.$store.getters['systemOption/optionTypes']
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          valueBoolean: null,
          valueNumeric: null,
          valueAlpha: null,
          optionType: null,
          accessCodes: null,
          externalCode: null,
          systemArea: null,
          notes: null,
          modifiedDate: null,
          modifiedBy: null,
          changeLog: null,
          filter1: null,
          filter2: null,
          filter3: null,
          tenant: null,
          userGroup: null,
          maiUser: null,
          partyGroup: null,
          category: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// DataOption.vue?00da4f4b